'use client';

import { useEffect } from 'react';

import { initFirebaseAnalytics } from '../../firebase/analytics';

import { useCookieConsent } from './useCookieConsent';

export function useAnalyticsConsent() {
  const { preferences } = useCookieConsent();

  useEffect(() => {
    if (preferences.analytics) {
      initFirebaseAnalytics(true);
    }
  }, [preferences.analytics]);
}
